import * as React from 'react'
import { ComboboxPortal } from './portal'
import { ComboboxPositioner } from './positioner'
import { ComboboxPopup } from './popup'
import { ComboboxBackdrop } from './backdrop'

interface ComboboxContentProps extends React.ComponentProps<typeof ComboboxPopup> {
  showBackdrop?: boolean
  backdropClassName?: string
  sideOffset?: number
  anchor?: React.RefObject<HTMLElement | null>
}

function ComboboxContent({
  className,
  children,
  showBackdrop = false,
  backdropClassName,
  sideOffset = 4,
  anchor,
  ...props
}: ComboboxContentProps) {
  return (
    <ComboboxPortal>
      {showBackdrop && <ComboboxBackdrop className={backdropClassName} />}
      <ComboboxPositioner sideOffset={sideOffset} anchor={anchor}>
        <ComboboxPopup className={className} {...props}>
          {children}
        </ComboboxPopup>
      </ComboboxPositioner>
    </ComboboxPortal>
  )
}

export { ComboboxContent }
